import { getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import Typography from 'components/Typography';

const prefix = ['components', 'confirmActionModal'];

export const Content = styled.div`
  text-align: center;
  min-height: 260px;
  padding-bottom: 20px;
`;

export const Title = styled(Typography)`
  margin-top: 14px;
  color: ${getPrefixedVar(prefix, 'title')};
`;

export const Message = styled(Typography)<{ $fullWidth?: boolean }>`
  color: ${getPrefixedVar(prefix, 'message')};
  white-space: pre-wrap;
  text-align: left;
  ${({ $fullWidth }) =>
    !$fullWidth &&
    css`
      max-width: 400px;
      margin: 0 auto;
      text-align: center;
    `}
  margin-top: 32px;
`;
